// extracted by mini-css-extract-plugin
module.exports = {"marquee":"inner-marquee_marquee__vX671","scroll":"inner-marquee_scroll__w8RSD"};